package com.essntl.uikit.components.icons

import androidx.compose.material3.LocalContentColor
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color

@Composable
fun EsLargeIcon(
    res: String,
    isSvg: Boolean = false,
    tint : Color = LocalContentColor.current,
    modifier: Modifier = Modifier,
) {
    EsIcon(
        res = res,
        size = EsIconSize.Large,
        isSvg = isSvg,
        tint = tint,
        modifier = modifier,
    )
}